import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ChevronDown, Users, GraduationCap, Copy } from "lucide-react";
import { toast } from "sonner";

const Stat = ({ label, value, testid }) => (
  <div className="rounded-lg bg-[color:var(--ayur-cream-2)] px-3 py-2" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-wider text-[color:var(--ayur-mute)] font-mono-brand">{label}</div>
    <div className="text-lg font-semibold text-[color:var(--ayur-emerald)]">{value}</div>
  </div>
);

export const CollegeCard = ({ c }) => {
  const [open, setOpen] = useState(false);
  const id = c.college_id;
  const copy = () => { navigator.clipboard?.writeText(`${c.name}, ${c.address}`); toast.success("Address copied"); };
  return (
    <article className="paper-card bg-white p-5 flex flex-col gap-4 hover:-translate-y-0.5 transition-transform duration-200" data-testid={`college-card-${id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-serif-display text-lg leading-snug text-[color:var(--ayur-ink)]" data-testid={`college-name-${id}`}>{c.name}</h3>
          <p className="mt-1 text-xs text-[color:var(--ayur-mute)] flex items-center gap-1">
            <MapPin className="w-3.5 h-3.5 shrink-0" /> {c.district}, {c.state}
          </p>
        </div>
        <span className="shrink-0 text-[10px] font-mono-brand px-2 py-1 rounded-full bg-[color:var(--ayur-badge)] text-[color:var(--ayur-emerald)]" data-testid={`college-type-${id}`}>{c.type}</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <Stat label="BAMS seats" value={c.ug_seats} testid={`college-ug-${id}`} />
        <Stat label="PG seats" value={c.pg_seats} testid={`college-pg-${id}`} />
        <Stat label="College ID" value={<span className="text-sm">{id}</span>} />
      </div>
      {c.pg_subjects.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid={`college-subjects-${id}`}>
          {c.pg_subjects.map((s) => (
            <span key={s.name} className="text-[11px] px-2 py-0.5 rounded-full border border-[color:var(--ayur-border)] text-[color:var(--ayur-ink-2)]">
              <b className={s.degree === "MS" ? "text-[color:var(--ayur-terracotta)]" : "text-[color:var(--ayur-sage)]"}>{s.degree}</b> {s.name}
            </span>
          ))}
        </div>
      )}
      <p className="text-xs text-[color:var(--ayur-ink-2)] leading-relaxed">{c.address}
        <button onClick={copy} className="ml-1 inline-flex align-middle text-[color:var(--ayur-sage)]" aria-label="Copy address" data-testid={`college-copy-${id}`}><Copy className="w-3 h-3" /></button>
      </p>
      <button onClick={() => setOpen(!open)} className="text-xs font-semibold text-[color:var(--ayur-emerald)] flex items-center gap-1 self-start" data-testid={`college-toggle-permission-${id}`}>
        {open ? "Hide" : "View"} NCISM permission note <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="text-xs leading-relaxed text-[color:var(--ayur-ink-2)] bg-[color:var(--ayur-cream)] rounded-lg p-3" data-testid={`college-permission-${id}`}>{c.permission}</p>}
      <div className="mt-auto pt-3 border-t border-[color:var(--ayur-border)] flex items-center justify-between gap-2">
        <span className="text-xs text-[color:var(--ayur-ink-2)] flex items-center gap-1" data-testid={`college-scholars-${id}`}>
          <Users className="w-3.5 h-3.5" /> {c.scholar_count > 0 ? `${c.scholar_count} scholar${c.scholar_count > 1 ? "s" : ""} on VaidGram` : "Be the first scholar here"}
        </span>
        <Link to="/signup" className="text-xs font-semibold text-[color:var(--ayur-terracotta)] flex items-center gap-1 link-underline" data-testid={`college-join-${id}`}>
          <GraduationCap className="w-3.5 h-3.5" /> Join your batch
        </Link>
      </div>
    </article>
  );
};
